import handRaisedWithoutWaving from 'assets/images/characters/CarolinaMariadeJesus/hand-raised-without-waving.webp';
import ElevatedButton from 'components/ElevatedButton';
import Chat from 'containers/CompositionFeedback/Chat';
import {useCallback, useMemo, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

import styles from './WelcomeView.module.scss';

export interface WelcomeViewProps {
  compositionId?: string;
  studentFirstName: string;
}

function WelcomeView({
  studentFirstName,
  compositionId,
}: WelcomeViewProps): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChatEnd, setIsChatEnd] = useState(false);

  const onChatEndCallback = useCallback(() => {
    setIsChatEnd(true);
  }, []);

  const memoizedWelcomeMessage = useMemo(
    () => [
      `Ei, ${studentFirstName} Que bom que você cumpriu a missão e chegou até aqui...`,
      'Agora, vamos explorar as possibilidades de evolução que existem em seu texto?',
    ],
    [studentFirstName],
  );

  return (
    <>
      <section className={styles.wrapper}>
        {/* footer is first because of flex column-reverse */}
        <footer className={styles.buttonWrapper}>
          <ElevatedButton
            variant="primary"
            text="Vamos lá!"
            disabled={!isChatEnd}
            onClick={() =>
              navigate({
                pathname: `/atividades/escrita/${compositionId}/devolutiva/sentimentos`,
                search: location.search,
              })
            }
          />
        </footer>

        <Chat
          messageList={memoizedWelcomeMessage}
          imageUrl={handRaisedWithoutWaving}
          variant="character-bottom"
          onChatEnd={onChatEndCallback}
        />
      </section>
    </>
  );
}

export default WelcomeView;
